import { createContext, useContext } from 'react';
import type { IHttpClient } from '@wix/fe-essentials/http-client';

export interface HttpClientProps {
  httpClient?: IHttpClient;
}

export const HttpClientContext = createContext<HttpClientProps | undefined>(
  undefined,
);

export function useHttpClient() {
  const context = useContext(HttpClientContext);
  if (context === undefined) {
    throw new Error('useHttpClient must be used within a HttpClientProvider');
  }
  return context;
}
